define.alias("shared/components/shared/ui/mobile-redirect-prompt", "media/components/shared/ui/mobile-redirect-prompt");